// extracted by mini-css-extract-plugin
export default {"isAdditonal":"CleaningDetailRoute_isAdditonal__r4wPf","demoContainer":"CleaningDetailRoute_demoContainer__8sUht","demoOuterContainer":"CleaningDetailRoute_demoOuterContainer__nX4+j"};